import { ChatActionIcon as AgentIcon } from '@erp/ui/chat-action-icon';
import { cn } from '@/lib/utils';

interface AILoadingPanelProps {
  className?: string;
}

/**
 * Compact loading card shown in the AI panel area while a validation
 * agent is running but has not yet produced results.
 *
 * Styled to match SuggestedActionsPanel so the transition from loading
 * to results feels seamless.
 */
export function AILoadingPanel({ className }: AILoadingPanelProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-lg border-x border-t border-stone-200 bg-white px-3 py-2 dark:border-stone-700 dark:bg-stone-900',
        className,
      )}
    >
      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-stone-100 dark:bg-stone-800">
        <AgentIcon state="thinking" size={20} />
      </div>
      <span className="text-sm text-stone-500 dark:text-stone-400">
        AI is analyzing this order...
      </span>
    </div>
  );
}
